import * as React from 'react'
import { OnboardingComponentProps } from '.'
import { Text, Inset, Colors } from '@doordash/design-language'

export const InlineTextComponent: React.FC<OnboardingComponentProps> = ({
  stringList,
}: OnboardingComponentProps) => {
  return (
    <Inset verticalSize={Inset.Sizes.XxSmall} horizontalSize={Inset.Sizes.None}>
      {getInlineString(stringList)}
    </Inset>
  )
}
const SpaceElement = () => <Text display={Text.DisplayModes.Inline}> </Text>

const getInlineString = list =>
  list.reduce((prev, curr, index) => {
    const { label, href } = curr
    const stringElement = (
      <Text
        display={Text.DisplayModes.Inline}
        color={href ? Colors.ButtonPlainForeground : Colors.TextTertiary}
        target={href ? '_blank' : null}
        tag={href ? 'a' : 'div'}
        href={href}
      >
        {label}
      </Text>
    )
    prev.push(stringElement)
    if (index !== list.length - 1) {
      prev.push(SpaceElement())
    }
    return prev
  }, [])
